// CANONICAL COPY (GH #7115). src/constants/obligations/obl-outsourced-development.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-outsourced-development',
  title: 'Review outsourced development and third-party software components',
  description:
    'Confirm that outsourced software development activities are supervised and monitored, with security requirements applied to suppliers and contractors involved in development. Third-party software components (libraries, frameworks, packages) used in development shall be inventoried, kept up to date, monitored for known vulnerabilities, and sourced only from trusted repositories. Review supplier development security agreements and the third-party component inventory on a defined cadence.',
  category: 'vendors',
  scfIds: ['SCF-DEV-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Outsourced development / third-party component policy is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
